// DO NOT EDIT!!! This file is auto-generated.
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fi from "./locales/fi.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";

export const LOCALES_SUPPORTED = [
  "de",
  "en",
  "es",
  "fi",
  "fr",
  "it",
  "ja",
] as const;
export const LOCALE_DEFAULT = "en";

export type LocaleSupported = (typeof LOCALES_SUPPORTED)[number];
export type LocaleTextJson = Record<MessageKey, string>;
type Messages = Record<LocaleSupported, LocaleTextJson>;
export const MESSAGES: Messages = {
  de: de,
  en: en,
  es: es,
  fi: fi,
  fr: fr,
  it: it,
  ja: ja,
};
export const getMessagesForLocale = (
  locale: LocaleSupported = LOCALE_DEFAULT,
) => MESSAGES[locale];

export type MessageKey =
  | "checkout_payment_3ds_error"
  | "checkout_payment_authentication_error"
  | "checkout_payment_avs_error"
  | "checkout_payment_bank_rejected"
  | "checkout_payment_captcha_error"
  | "checkout_payment_funds_error"
  | "checkout_payment_generic_error"
  | "checkout_payment_invalid_card_error"
  | "checkout_payment_max_attempts"
  | "country_AD"
  | "country_AE"
  | "country_AF"
  | "country_AG"
  | "country_AI"
  | "country_AL"
  | "country_AM"
  | "country_AO"
  | "country_AQ"
  | "country_AR"
  | "country_AS"
  | "country_AT"
  | "country_AU"
  | "country_AW"
  | "country_AX"
  | "country_AZ"
  | "country_BA"
  | "country_BB"
  | "country_BD"
  | "country_BE"
  | "country_BF"
  | "country_BG"
  | "country_BH"
  | "country_BI"
  | "country_BJ"
  | "country_BL"
  | "country_BM"
  | "country_BN"
  | "country_BO"
  | "country_BQ"
  | "country_BR"
  | "country_BS"
  | "country_BT"
  | "country_BV"
  | "country_BW"
  | "country_BY"
  | "country_BZ"
  | "country_CA"
  | "country_CC"
  | "country_CD"
  | "country_CF"
  | "country_CG"
  | "country_CH"
  | "country_CI"
  | "country_CK"
  | "country_CL"
  | "country_CM"
  | "country_CN"
  | "country_CO"
  | "country_CR"
  | "country_CU"
  | "country_CV"
  | "country_CW"
  | "country_CX"
  | "country_CY"
  | "country_CZ"
  | "country_DE"
  | "country_DJ"
  | "country_DK"
  | "country_DM"
  | "country_DO"
  | "country_DZ"
  | "country_EA"
  | "country_EC"
  | "country_EE"
  | "country_EG"
  | "country_EH"
  | "country_ER"
  | "country_ES"
  | "country_ET"
  | "country_FI"
  | "country_FJ"
  | "country_FK"
  | "country_FM"
  | "country_FO"
  | "country_FR"
  | "country_GA"
  | "country_GB"
  | "country_GD"
  | "country_GE"
  | "country_GF"
  | "country_GG"
  | "country_GH"
  | "country_GI"
  | "country_GL"
  | "country_GM"
  | "country_GN"
  | "country_GP"
  | "country_GQ"
  | "country_GR"
  | "country_GS"
  | "country_GT"
  | "country_GU"
  | "country_GW"
  | "country_GY"
  | "country_HK"
  | "country_HM"
  | "country_HN"
  | "country_HR"
  | "country_HT"
  | "country_HU"
  | "country_IC"
  | "country_ID"
  | "country_IE"
  | "country_IL"
  | "country_IM"
  | "country_IN"
  | "country_IO"
  | "country_IQ"
  | "country_IR"
  | "country_IS"
  | "country_IT"
  | "country_JE"
  | "country_JM"
  | "country_JO"
  | "country_JP"
  | "country_KE"
  | "country_KG"
  | "country_KH"
  | "country_KI"
  | "country_KM"
  | "country_KN"
  | "country_KP"
  | "country_KR"
  | "country_KW"
  | "country_KY"
  | "country_KZ"
  | "country_LA"
  | "country_LB"
  | "country_LC"
  | "country_LI"
  | "country_LK"
  | "country_LR"
  | "country_LS"
  | "country_LT"
  | "country_LU"
  | "country_LV"
  | "country_LY"
  | "country_MA"
  | "country_MC"
  | "country_MD"
  | "country_ME"
  | "country_MF"
  | "country_MG"
  | "country_MH"
  | "country_MK"
  | "country_ML"
  | "country_MM"
  | "country_MN"
  | "country_MO"
  | "country_MP"
  | "country_MQ"
  | "country_MR"
  | "country_MS"
  | "country_MT"
  | "country_MU"
  | "country_MV"
  | "country_MW"
  | "country_MX"
  | "country_MY"
  | "country_MZ"
  | "country_NA"
  | "country_NC"
  | "country_NE"
  | "country_NF"
  | "country_NG"
  | "country_NI"
  | "country_NL"
  | "country_NO"
  | "country_NP"
  | "country_NR"
  | "country_NU"
  | "country_NZ"
  | "country_OM"
  | "country_PA"
  | "country_PE"
  | "country_PF"
  | "country_PG"
  | "country_PH"
  | "country_PK"
  | "country_PL"
  | "country_PM"
  | "country_PN"
  | "country_PR"
  | "country_PS"
  | "country_PT"
  | "country_PW"
  | "country_PY"
  | "country_QA"
  | "country_RE"
  | "country_RO"
  | "country_RS"
  | "country_RU"
  | "country_RW"
  | "country_SA"
  | "country_SB"
  | "country_SC"
  | "country_SD"
  | "country_SE"
  | "country_SG"
  | "country_SH"
  | "country_SI"
  | "country_SJ"
  | "country_SK"
  | "country_SL"
  | "country_SM"
  | "country_SN"
  | "country_SO"
  | "country_SR"
  | "country_SS"
  | "country_ST"
  | "country_SV"
  | "country_SX"
  | "country_SY"
  | "country_SZ"
  | "country_TC"
  | "country_TD"
  | "country_TF"
  | "country_TG"
  | "country_TH"
  | "country_TJ"
  | "country_TK"
  | "country_TL"
  | "country_TM"
  | "country_TN"
  | "country_TO"
  | "country_TR"
  | "country_TT"
  | "country_TV"
  | "country_TW"
  | "country_TZ"
  | "country_UA"
  | "country_UG"
  | "country_UM"
  | "country_US"
  | "country_UY"
  | "country_UZ"
  | "country_VA"
  | "country_VC"
  | "country_VE"
  | "country_VG"
  | "country_VI"
  | "country_VN"
  | "country_VU"
  | "country_WF"
  | "country_WS"
  | "country_XI"
  | "country_XK"
  | "country_YE"
  | "country_YT"
  | "country_ZA"
  | "country_ZM"
  | "country_ZW"
  | "membership_addressform_error_address1_missing"
  | "membership_addressform_error_city_missing"
  | "membership_addressform_error_country_missing"
  | "membership_addressform_error_firstname_missing"
  | "membership_addressform_error_lastname_missing"
  | "membership_addressform_error_state_missing"
  | "membership_addressform_error_too_long"
  | "membership_addressform_error_zipcode_invalid"
  | "membership_addressform_error_zipcode_missing"
  | "membership_error_agreement_required"
  | "membership_error_email_not_found_for_cloudaccount"
  | "membership_error_error_occured"
  | "membership_error_exchange_token_jwt"
  | "membership_error_failed_payment_signature_creation"
  | "membership_error_getting_countries"
  | "membership_error_getting_offerings"
  | "membership_error_invalid_credit_card"
  | "membership_error_invalid_credit_card_type"
  | "membership_error_invalid_cvv"
  | "membership_error_invalid_email"
  | "membership_error_invalid_token_format"
  | "membership_error_membership_addressvalidation_failed"
  | "membership_error_missing_access_token"
  | "membership_error_missing_dynamic_hosted_page_params"
  | "membership_error_missing_email_hub"
  | "membership_error_missing_email_signup_login"
  | "membership_error_missing_payment_method_hub_login"
  | "membership_error_missing_signup_token"
  | "membership_error_missing_url"
  | "membership_error_missing_usertype_from_offering"
  | "membership_error_new_email_validation"
  | "membership_error_no_product_found"
  | "membership_error_no_subscription_created"
  | "membership_error_not_allowed_to_create_sub_without_entitlement"
  | "membership_error_on_account_update"
  | "membership_error_on_address_validation"
  | "membership_error_on_change_subscription_plan"
  | "membership_error_on_get_account"
  | "membership_error_on_getting_offerings"
  | "membership_error_on_renew_subscription"
  | "membership_error_on_reset_password_token_missing"
  | "membership_error_on_verify_email_magic_link_token_missing"
  | "membership_error_onetime_token_used"
  | "membership_error_page_not_found"
  | "membership_error_page_you_are_looking_for_not_exists"
  | "membership_error_password_requirements"
  | "membership_error_required_field"
  | "membership_error_unknown"
  | "membership_home_address"
  | "membership_hub_accessibility_navigate_to"
  | "membership_hub_account_information"
  | "membership_hub_account_management"
  | "membership_hub_add_payment_method"
  | "membership_hub_address_page_invalid_field"
  | "membership_hub_address_page_sub_text"
  | "membership_hub_address_page_validation_error"
  | "membership_hub_address_page_validation_general_error"
  | "membership_hub_address_validation_suggestion_edit_entered_address"
  | "membership_hub_address_validation_suggestion_entered_address_header"
  | "membership_hub_address_validation_suggestion_header"
  | "membership_hub_address_validation_suggestion_suggested_address_header"
  | "membership_hub_address_validation_suggestion_text"
  | "membership_hub_address_validation_suggestion_use_selected_address"
  | "membership_hub_b2b_plan_description"
  | "membership_hub_b2c_no_subscription_no_access"
  | "membership_hub_billing_address"
  | "membership_hub_billing_history_header"
  | "membership_hub_billing_information"
  | "membership_hub_billing_payment_details"
  | "membership_hub_billing_status"
  | "membership_hub_billing_status_active"
  | "membership_hub_billing_status_active_description_b2b_membership"
  | "membership_hub_billing_status_active_description_lifetime_membership"
  | "membership_hub_billing_status_active_description_next_payment_on"
  | "membership_hub_billing_status_dormant_subscription"
  | "membership_hub_billing_status_inactive"
  | "membership_hub_billing_status_inactive_description_b2b_membership"
  | "membership_hub_billing_status_payment_failed"
  | "membership_hub_billing_status_payment_failed_description_dunning"
  | "membership_hub_billing_status_payment_required"
  | "membership_hub_billing_status_pending_cancellation"
  | "membership_hub_billing_status_pending_cancellation_description"
  | "membership_hub_cancel_dialog_cancel_membership"
  | "membership_hub_cancel_dialog_fine_print"
  | "membership_hub_cancel_dialog_keep_my_membership"
  | "membership_hub_cancel_dialog_learn_more"
  | "membership_hub_cancel_dialog_subtile_first"
  | "membership_hub_cancel_dialog_subtitle_second"
  | "membership_hub_cancel_dialog_title"
  | "membership_hub_cancel_membership"
  | "membership_hub_cancel_membership_disclaimer"
  | "membership_hub_cancellation_modal_body_text_1"
  | "membership_hub_cancellation_modal_body_text_2"
  | "membership_hub_check_your_email"
  | "membership_hub_choose_ongoing_plan_after_prepaid"
  | "membership_hub_confirm_modal_plan_renew"
  | "membership_hub_continue"
  | "membership_hub_cta_update_payment_method"
  | "membership_hub_current_plan_title"
  | "membership_hub_days_left"
  | "membership_hub_download_invoices"
  | "membership_hub_edit_account_info"
  | "membership_hub_edit_payment_method"
  | "membership_hub_email"
  | "membership_hub_email_required_error_message"
  | "membership_hub_enter_current_password"
  | "membership_hub_enter_email"
  | "membership_hub_enter_email_for_reset_link"
  | "membership_hub_enter_new_password"
  | "membership_hub_enter_password"
  | "membership_hub_entitlment_user_member_experience_page_subtitle"
  | "membership_hub_experience_card_body_temp"
  | "membership_hub_experience_card_heart_rate"
  | "membership_hub_experience_card_indepth"
  | "membership_hub_experience_card_personalized"
  | "membership_hub_experience_subtitle"
  | "membership_hub_experience_subtitle_exclusive_promotions"
  | "membership_hub_experience_subtitle_features"
  | "membership_hub_experience_subtitle_insights"
  | "membership_hub_experience_subtitle_latest_and_greatest"
  | "membership_hub_experience_text_exclusive_promotions"
  | "membership_hub_experience_text_features"
  | "membership_hub_experience_text_insights"
  | "membership_hub_experience_text_latest_and_greatest"
  | "membership_hub_experience_title"
  | "membership_hub_experience_title_body"
  | "membership_hub_expired_payment_method"
  | "membership_hub_feature_name"
  | "membership_hub_finish_onboarding_flow"
  | "membership_hub_first_month_on_us"
  | "membership_hub_forgot_password"
  | "membership_hub_general_error"
  | "membership_hub_inactive_description_get_membership_benefits"
  | "membership_hub_introducing_oura_ring_gen3"
  | "membership_hub_introducing_oura_ring_gen3_body"
  | "membership_hub_invalid_password"
  | "membership_hub_lifetime_membership"
  | "membership_hub_login_button"
  | "membership_hub_login_failed_error_message"
  | "membership_hub_logout"
  | "membership_hub_member_experience"
  | "membership_hub_member_experience_sub_title"
  | "membership_hub_member_since"
  | "membership_hub_membership_plan"
  | "membership_hub_membership_plan_next_payment"
  | "membership_hub_membership_plan_type_annual"
  | "membership_hub_membership_plan_type_monthly"
  | "membership_hub_membership_setup"
  | "membership_hub_monthly_plan"
  | "membership_hub_monthly_price"
  | "membership_hub_monthly_product"
  | "membership_hub_monthly_product_plan"
  | "membership_hub_no_billing_history"
  | "membership_hub_not_connected_gen2"
  | "membership_hub_one_day_left"
  | "membership_hub_ongoing_plan"
  | "membership_hub_password"
  | "membership_hub_password_changed"
  | "membership_hub_password_required_error_message"
  | "membership_hub_password_reset_successful"
  | "membership_hub_payment_details"
  | "membership_hub_payment_method"
  | "membership_hub_payment_method_subtitle_monthly_price"
  | "membership_hub_payment_method_subtitle_yearly_price"
  | "membership_hub_payment_method_update_success"
  | "membership_hub_payment_method_update_success_body_text"
  | "membership_hub_payment_required_description"
  | "membership_hub_plan_confirm_modal_text"
  | "membership_hub_prepaid"
  | "membership_hub_prepaid_subtitle_1"
  | "membership_hub_prepaid_subtitle_2"
  | "membership_hub_prepaid_title"
  | "membership_hub_product_page_subtitle"
  | "membership_hub_product_page_title"
  | "membership_hub_pw_creation_requirement_min_length"
  | "membership_hub_pw_creation_requirement_policy"
  | "membership_hub_pw_reset_link_expired"
  | "membership_hub_pw_reset_link_is_expired"
  | "membership_hub_renew_legal"
  | "membership_hub_renew_membership"
  | "membership_hub_renew_notification_body"
  | "membership_hub_renew_submit"
  | "membership_hub_renew_with_payment"
  | "membership_hub_reset_password"
  | "membership_hub_reset_password_email_instructions"
  | "membership_hub_return_to_hub_home"
  | "membership_hub_select_all"
  | "membership_hub_send_link_to_email"
  | "membership_hub_switch_to_annual_plan"
  | "membership_hub_try_again_error"
  | "membership_hub_unverified_account"
  | "membership_hub_unverified_account_link_label"
  | "membership_hub_upcoming_plan_title"
  | "membership_hub_update"
  | "membership_hub_update_account_information_text"
  | "membership_hub_update_email"
  | "membership_hub_update_email_input"
  | "membership_hub_update_membership_password"
  | "membership_hub_update_membership_plan_link"
  | "membership_hub_update_password"
  | "membership_hub_update_payment_info"
  | "membership_hub_update_payment_method"
  | "membership_hub_update_product_page_subtitle"
  | "membership_hub_upgrade_to_gen3"
  | "membership_hub_verify_email"
  | "membership_hub_verify_email_magic_link_expired"
  | "membership_hub_verifying_your_email"
  | "membership_hub_view_billing_history"
  | "membership_hub_view_membership_plan"
  | "membership_hub_view_order_status"
  | "membership_hub_view_payment_details_page"
  | "membership_hub_welcome"
  | "membership_hub_welcome_back"
  | "membership_hub_x_month_trial"
  | "membership_hub_yearly_plan"
  | "membership_hub_yearly_price"
  | "membership_hub_yearly_product"
  | "membership_hub_yearly_product_plan"
  | "membership_reset_password_rate_limit_over"
  | "membership_reset_password_user_not_found"
  | "membership_signup_accessibility"
  | "membership_signup_account_created_success_message"
  | "membership_signup_account_created_success_message_gen2"
  | "membership_signup_account_created_title"
  | "membership_signup_account_password_new_password"
  | "membership_signup_account_password_title"
  | "membership_signup_account_setup_exclusivehealth"
  | "membership_signup_account_setup_exclusivehealth.33"
  | "membership_signup_account_setup_readandagree"
  | "membership_signup_all_rights_reserved"
  | "membership_signup_billing_address_address2_field"
  | "membership_signup_billing_address_address_field"
  | "membership_signup_billing_address_billing_apt"
  | "membership_signup_billing_address_billing_state"
  | "membership_signup_billing_address_billing_zip"
  | "membership_signup_billing_address_city_field"
  | "membership_signup_billing_address_country_field"
  | "membership_signup_billing_address_enter_address"
  | "membership_signup_billing_address_filled_step2"
  | "membership_signup_billing_address_first_name_field"
  | "membership_signup_billing_address_home_address_required"
  | "membership_signup_billing_address_last_name_field"
  | "membership_signup_billing_address_physicaladdressrequired"
  | "membership_signup_billing_address_title"
  | "membership_signup_button_back"
  | "membership_signup_button_next"
  | "membership_signup_error_unknown"
  | "membership_signup_fallback_name"
  | "membership_signup_ip_notice"
  | "membership_signup_payment_disclaimer"
  | "membership_signup_payment_method_CC"
  | "membership_signup_payment_method_automaticrenewal"
  | "membership_signup_payment_method_button_checkout"
  | "membership_signup_payment_method_button_submit"
  | "membership_signup_payment_method_ccnumber"
  | "membership_signup_payment_method_clickbelow"
  | "membership_signup_payment_method_creditcard_expiracy_placeholder"
  | "membership_signup_payment_method_cvv"
  | "membership_signup_payment_method_expirationdate"
  | "membership_signup_payment_method_expirationyear"
  | "membership_signup_payment_method_link_back"
  | "membership_signup_payment_method_name"
  | "membership_signup_payment_method_step3"
  | "membership_signup_payment_method_subtitle"
  | "membership_signup_payment_method_subtitle_monthly_price"
  | "membership_signup_payment_method_subtitle_yearly_price"
  | "membership_signup_payment_method_title"
  | "membership_signup_paypal_checkout_text"
  | "membership_signup_physical_address"
  | "membership_signup_physical_address_billing_address"
  | "membership_signup_privacy_policy"
  | "membership_signup_privacypolicy_link_text"
  | "membership_signup_step"
  | "membership_signup_support"
  | "membership_signup_terms_conditions"
  | "membership_signup_termsandconditions_link_text"
  | "membership_signup_trademarks"
  | "membership_signup_welcome_page_button_getstarted"
  | "membership_signup_welcome_page_first_month"
  | "membership_signup_welcome_page_subtitle"
  | "membership_signup_welcome_page_title";
